module.exports = __webpack_public_path__ + "static/img/rongyu2.2eb0bac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rongyu2.jpg
// module id = u7Of
// module chunks = 1